import { useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { LoginWrapper } from "./styled";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useLocation, useNavigate } from "react-router-dom";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { LoginRightImage } from "../../../components/styled/AllImages";
import ForgetPasswordModal from "./components/ForgetPasswordModal";
import EmailSentModal from "./components/EmailSentModal";
import { emailRegex } from "../../../utils";
import { toast } from "react-toastify";
import useAuth from "../../../context/authContext";
import AuthApi from "../../../services/api/authApi";
import { useUser } from "../../../context/userContext";

const Login = () => {
  const { i18n } = useTranslation();
  const { login } = useAuth();
  const { fetchUserInfo } = useUser();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  const planType = queryParams.get("plan_type");

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  // States
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passResetLoading, setPassResetLoading] = useState(false);
  const [emailSentModalShow, setEmailSentModalShow] = useState(false);

  const reqPasswordReset = async (email) => {
    try {
      setPassResetLoading(true);
      const { code, message } = await AuthApi.reqPasswordReset(email);
      if (code === 200) {
        toast.success(message);
        setShowModal(false);
        setEmailSentModalShow(true);
      }
      if (code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setPassResetLoading(false);
    }
  };

  // OnChange and other Methods
  const handleBtnClick = (email) => {
    reqPasswordReset(email);
  };

  const onSubmit = async (credentials) => {
    try {
      setLoading(true);
      const response = await AuthApi.login(credentials);
      if (response.code === 200) {
        if (response?.data?.token) {
          login(response?.data?.token);
          await fetchUserInfo();
          toast.success(t("logged_in_successfully"));
          navigate("/products-categories");
        }
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
      if (response.code === 400) {
        toast.error(response.error);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const clearParams = () => {
    navigate(location.pathname, { replace: true });
  };

  useEffect(() => {
    if (status) {
      if (status === "CAPTURED") {
        if (planType === "private") {
          toast.success(t("payment_process_successful")); // you can customize this message
          clearParams();
        } else {
          toast.success(t("registered_successfully")); // you can customize this message
          clearParams();
        }
      } else if (status === "DECLINED") {
        toast.error(t("payment_failed")); // you can customize this message
        clearParams();
      } else if (status === "FAILED") {
        toast.error(t("payment_failed_2"));
        clearParams();
      }
    }
  }, [status]);

  return (
    <LoginWrapper lang={i18n.language}>
      <AuthHeader />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="mt-4 container-fluid pb-4">
          <Row>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 overflow-y-auto">
              <Box className="mb-4">
                <HeadingStyled size="24px" weight="bold" color="var(--text)">
                  {t("welcome_back")}
                </HeadingStyled>
                <TextStyled size="16px" color="var(--text2)">
                  {t("please_enter_email_password")}
                </TextStyled>
              </Box>
              <Box>
                <Box>
                  <ValidatedInput
                    weight="600"
                    name="email"
                    label={"email"}
                    type="input"
                    fieldType="text"
                    placeholder={"emailPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                      inline: true,
                      pattern: {
                        value: emailRegex,
                        message: "invalidEmail",
                      },
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <ValidatedInput
                    weight="600"
                    name="password"
                    label={"password"}
                    type="input"
                    fieldType="password"
                    placeholder={"passwordPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                      inline: true,
                      minLength: {
                        value: 8,
                        message: "lengthGreaterThen",
                      },
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <FormButtonStyled
                    label={t("login")}
                    color="var(--white)"
                    bg="var(--themeColor)"
                    className="w-100"
                    clName="w-100 my-4"
                    type="submit"
                    isLoading={loading}
                  />
                </Box>
                <Box className="d-flex justify-content-center justify-content-sm-end mb-3">
                  <Box>
                    <TextStyled
                      className="cursor-pointer"
                      color="var(--themeColor)"
                      size="16px"
                      weight="500"
                      onClick={() => setShowModal(true)}
                    >
                      {t("forgot_password")}
                    </TextStyled>
                  </Box>
                </Box>
                {/* <Box>
                  <Box>
                    <TextStyled
                      className="justify-content-center align-items-center or-separator"
                      color="var(--text2)"
                      size="16px"
                    >
                      {t("or")}
                    </TextStyled>
                  </Box>
                </Box>
                <FormButtonStyled
                  label={t("login_with_phone_num")}
                  color="var(--text)"
                  bg="var(--white)"
                  className="w-100"
                  clName="w-100 my-4"
                  weight="600"
                  onClick={() => navigate("/login-with-phone")}
                />
                <p className="text-center" style={{ color: "var(--text2)" }}>
                  {t("dont_have_an_account")}{" "}
                  <span
                    onClick={() => navigate(`/signup`)}
                    style={{ color: "var(--themeColor)", cursor: "pointer" }}
                  >
                    {t("sign_up")}
                  </span>
                </p> */}
              </Box>
            </Col>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
              <Box className="sticky-item">
                <Box style={{ position: "relative" }}>
                  <Box className="image-title">
                    <Box>
                      <span className="image-title-one">
                        {t("welcome_to")}{" "}
                      </span>{" "}
                      <span className="image-title-two">{t("my_office")}</span>
                    </Box>
                    <p className="image-title-sub-title">
                      {t("streamline_your_workspace")}
                    </p>
                  </Box>
                  <LazyImage src={LoginRightImage} />
                </Box>
                {/* <AuthSlider
                  slides={i18n.language === "en" ? AuthSlides : AuthSlidesAr}
                /> */}
              </Box>
            </Col>
          </Row>
        </Box>
      </Form>
      <ForgetPasswordModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onBtnClick={handleBtnClick}
        loading={passResetLoading}
      />
      <EmailSentModal
        show={emailSentModalShow}
        onHide={() => setEmailSentModalShow(false)}
      />
    </LoginWrapper>
  );
};

export default Login;
